// Custom Icons
import React from "react";

import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { aplicarTema, temaEscuroAtivo } from "../../utils/tema";
export default function FixedPlugin(props: { [s: string]: any }) {
  const { ...rest } = props;
  const [darkmode, setDarkmode] = React.useState(temaEscuroAtivo);

  return (
    <button
      className="dv-sheen fixed bottom-[30px] right-[35px] !z-[99] flex h-[60px] w-[60px] items-center justify-center rounded-full border border-white/20 bg-dv-gradient p-0 shadow-dv-glow transition-transform hover:scale-105 active:scale-95"
      onClick={() => {
        aplicarTema(!darkmode);
        setDarkmode(!darkmode);
      }}
      {...rest}
    >
      {/* // left={document.documentElement.dir === "rtl" ? "35px" : ""}
      // right={document.documentElement.dir === "rtl" ? "" : "35px"} */}
      <div className="cursor-pointer text-gray-600">
        {darkmode ? (
          <RiSunFill className="h-4 w-4 text-white" />
        ) : (
          <RiMoonFill className="h-4 w-4 text-white" />
        )}
      </div>
    </button>
  );
}
